import { useEffect, useState } from "react";
import { useApp } from "../../../hooks/AppProvider";
import { Table } from "../../../components/BasicComponents";

function GameMyViewTable({ attributions }) {
    return (
        <Table headers={["Nom de l'élève", "Jeu attribué"]}>
            {attributions.map(data => (
                <GameMyViewRow key={data.student_id} studentName={data.student_name} gameName={data.game_name} />
            ))}
        </Table>
    );
}

function GameMyViewRow({ studentName, gameName }) {
    return (
        <tr>
            <td>{studentName}</td>
            <td>{gameName}</td>
        </tr>
    );
}

function GameMyView() {
    let app = useApp();
    
    let [attributions, setAttributions] = useState([]);

    useEffect(() => {
        app.sendGet("/game/listmy/attributions", data => {
            setAttributions(data);
        });
    }, []);

    return (
        <div className="main-content">
            <h1>Attributions pour ma classe</h1>
            <GameMyViewTable attributions={attributions} />
        </div>
    );
}

export default GameMyView;